// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay_cSORO {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--_00000020-background);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal_pwEji {
  background-color: var(--white-background);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 8px 20px var(--_00000033-shadow);
  animation: fadeInUp_HeRhg 0.3s ease-out;
}

@keyframes fadeInUp_HeRhg {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.title_zNZwi {
  margin: 0;
  font-size: 1.2rem;
  color: #333;
}

.parrafo_hhYOa {
  margin: 10px 0;
  font-size: 0.8rem;
  color: #444;
  line-height: 1.5;
}

.label_GdTBm {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  font-weight: bold;
 color: var(--_3-color);
}

.label_GdTBm span {
  display: contents;
  font-weight: normal;
  color: var(--_6-color);
}

.input_qj6vV {
  margin-top: 4px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 0.9rem;
  font-family: inherit;
}
.input_qj6vV::placeholder {
  color: #999; 
  opacity: 1;  
}

.buttonGroup_PI4oM {
  display: flex;
  margin-top: auto;
  width: fit-content;
  background-color: var(--f1-background);
  padding: 2px;
  border-radius: 4px;
}

.button_CLDiC {
   all: unset;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background-color 0.2s;
  padding: 6px 12px;
  border-radius: 4px;
  color: var(--_6-color);
  font-weight: bold;
}

.button_CLDiC:hover {
  background-color: var(--white-background);
  color:var(--black-color)
}

.left_XgN2p {
}

.right_YXCP6 {
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/GeneralSettings/components/ConnectedApps/tokenModal/tokenModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,8CAA8C;EAC9C,uCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;CAClB,sBAAsB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;GACG,UAAU;EACX,iBAAiB;EACjB,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC;AACF;;AAEA;AACA;;AAEA;AACA","sourcesContent":[".overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--_00000020-background);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.modal {\n  background-color: var(--white-background);\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  box-shadow: 0 8px 20px var(--_00000033-shadow);\n  animation: fadeInUp 0.3s ease-out;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.title {\n  margin: 0;\n  font-size: 1.2rem;\n  color: #333;\n}\n\n.parrafo {\n  margin: 10px 0;\n  font-size: 0.8rem;\n  color: #444;\n  line-height: 1.5;\n}\n\n.label {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 10px;\n  font-weight: bold;\n color: var(--_3-color);\n}\n\n.label span {\n  display: contents;\n  font-weight: normal;\n  color: var(--_6-color);\n}\n\n.input {\n  margin-top: 4px;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-family: inherit;\n}\n.input::placeholder {\n  color: #999; \n  opacity: 1;  \n}\n\n.buttonGroup {\n  display: flex;\n  margin-top: auto;\n  width: fit-content;\n  background-color: var(--f1-background);\n  padding: 2px;\n  border-radius: 4px;\n}\n\n.button {\n   all: unset;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  padding: 6px 12px;\n  border-radius: 4px;\n  color: var(--_6-color);\n  font-weight: bold;\n}\n\n.button:hover {\n  background-color: var(--white-background);\n  color:var(--black-color)\n}\n\n.left {\n}\n\n.right {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `overlay_cSORO`,
	"modal": `modal_pwEji`,
	"fadeInUp": `fadeInUp_HeRhg`,
	"title": `title_zNZwi`,
	"parrafo": `parrafo_hhYOa`,
	"label": `label_GdTBm`,
	"input": `input_qj6vV`,
	"buttonGroup": `buttonGroup_PI4oM`,
	"button": `button_CLDiC`,
	"left": `left_XgN2p`,
	"right": `right_YXCP6`
};
export default ___CSS_LOADER_EXPORT___;
